import axiosInstance from "./BaseService";

// Interface for YouTube video data
export interface YoutubeVideoData {
  _id: string;
  title: string;
  description?: string;
  videoUrl: string;
  thumbnailUrl: string;
  isActive: boolean;
  isSpecial: boolean;
  showFromDate?: string;
  showToDate?: string;
  createdAt: string;
  updatedAt: string;
}

// Fetch all YouTube videos with pagination and search
export const fetchYoutubeVideos = async (
  page: number = 1, 
  limit: number = 12,
  search: string = ""
): Promise<{
  videos: YoutubeVideoData[];
  total: number;
  totalPages: number;
  currentPage: number;
}> => {
  try {
    const params = {
      page: page.toString(),
      limit: limit.toString(),
      isActive: "true",
      ...(search && { search })
    };
    
    const response = await axiosInstance.get('/youtube-videos', { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching YouTube videos:", error);
    return { videos: [], total: 0, totalPages: 0, currentPage: 1 };
  }
};

// Fetch YouTube video by ID
export const fetchYoutubeVideoById = async (id: string): Promise<YoutubeVideoData> => {
  try {
    const response = await axiosInstance.get(`/youtube-videos/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching YouTube video:", error);
    throw error;
  }
};

export const createYoutubeVideo = async (videoData: { showFromDate: string | null; showToDate: string | null; title: string; description: string; videoUrl: string; isActive: boolean; isSpecial: boolean; }): Promise<YoutubeVideoData> => {
  try {
    const response = await axiosInstance.post('/youtube-videos', videoData);
    return response.data;
  } catch (error) {
    console.error("Error creating YouTube video:", error);
    throw error;
  }
}

export const updateYoutubeVideo = async (id: string, videoData: { showFromDate: string | null; showToDate: string | null; title: string; description: string; videoUrl: string; isActive: boolean; isSpecial: boolean; }): Promise<YoutubeVideoData> => {
  try {
    const response = await axiosInstance.put(`/youtube-videos/${id}`, videoData);
    return response.data;
  } catch (error) {
    console.error("Error updating YouTube video:", error);
    throw error;
  }
}

export const deleteYoutubeVideo = async (id: string): Promise<void> => {
  try {
    await axiosInstance.delete(`/youtube-videos/${id}`);
  } catch (error) {
    console.error("Error deleting YouTube video:", error);
    throw error;
  }
}